import FormHeader from '../../../../../components/common/FormHeader';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PasswordChanged = () => {
  const { t } = useTranslation();

  return (
    <div className="auth-page">
      <div className="form-reset-new">
        <FormHeader title={t('auth.passwordChanged')} />

        <Link to="/signin" className="mg-btn mg-btn--primary mg-btn--block mg-mb-3">
          {t('auth.signIn')}
        </Link>
      </div>
    </div>
  );
};

export default PasswordChanged;
